import type {Environment} from '@github-ui/agent-sessions-types/environment'
import type {EnvironmentOption} from './environment-option'
import {isAhpVersionSupported} from '@github-ui/ahp-relay/protocol-support'

/**
 * Reports whether the currently selected environment can no longer be targeted
 * and should be cleared by its owner.
 *
 * Only `ahp` selections can go stale: the chosen environment may have gone
 * offline/draining/etc., started reporting an AHP version this client can't
 * speak, or dropped out of the list entirely. Cloud selections are always
 * valid. While the environment list has not loaded yet (`environments` is
 * undefined) nothing is considered stale, so an in-flight fetch never clears a
 * valid selection.
 */
export function isEnvironmentSelectionStale(
  selectedEnvironment: EnvironmentOption | null | undefined,
  environments: Environment[] | undefined,
): boolean {
  if (selectedEnvironment?.kind !== 'ahp') return false
  if (!environments) return false
  return !environments.some(
    env =>
      env.id === selectedEnvironment.environmentId &&
      env.status === 'online' &&
      isAhpVersionSupported(env.capabilities?.ahp_version),
  )
}
